<template>
  <v-container class="py-8">
    <!-- Título -->
    <v-row class="mb-4">
      <v-col cols="12">
        <div class="text-h4 font-weight-bold">Calendario de vencimientos</div>
        <div class="text-subtitle-1" style="color: #555;">
          Visualiza fácilmente las fechas en las que debes adelantar, cobrar o liquidar facturas.
        </div>
      </v-col>
    </v-row>

    <!-- Calendario -->
    <CalendarMonth
      :year="2025"
      :month="5"
      :facturas="facturas"
    />
  </v-container>
</template>

<script>
import CalendarMonth from '@/components/CalendarMonth.vue'

export default {
  components: {
    CalendarMonth
  },
  data() {
    return {
      focus: '',
      dialogoAbierto: false,
      elementoSeleccionado: null,
      eventoSeleccionado: {},
      facturas: [
        {
          id: 101,
          folio: 'F101',
          cliente: 'Cliente A',
          monto: 12000,
          estado: 'adelantar',
          fecha_vencimiento: '2025-06-11'
        },
        {
          id: 102,
          folio: 'F102',
          cliente: 'Cliente B',
          monto: 8700,
          estado: 'cobrar',
          fecha_vencimiento: '2025-06-11'
        },
        {
          id: 103,
          folio: 'F103',
          cliente: 'Cliente C',
          monto: 15000,
          estado: 'liquidar',
          fecha_vencimiento: '2025-06-12'
        },
        {
          id: 104,
          folio: 'F104',
          cliente: 'Cliente D',
          monto: 23000,
          estado: 'adelantar',
          fecha_vencimiento: '2025-06-04'
        }
      ]
    }
  },
  methods: {
    getEventColor(event) {
      switch (event.estado) {
        case 'adelantar': return 'orange darken-2'
        case 'cobrar': return 'green darken-2'
        case 'liquidar': return 'blue darken-2'
        default: return 'grey'
      }
    },
    mostrarEvento({ nativeEvent, event }) {
      this.eventoSeleccionado = event
      this.dialogoAbierto = true
      this.elementoSeleccionado = nativeEvent.currentTarget
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value)
    },
    capitalize(text) {
      if (!text) return ''
      return text.charAt(0).toUpperCase() + text.slice(1)
    }
  }
}
</script>
